import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/images/team.svg'
import _imports_1 from '../../assets/images/organigrama.jpg'


const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6" }
const _hoisted_2 = { class: "2xl:container 2xl:mx-auto md:py-12 lg:px-20 md:px-6 py-9 px-4" }
const _hoisted_3 = { class: "w-full flex flex-col justify-content-center items-center" }
const _hoisted_4 = { class: "font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-curaduria" }
const _hoisted_5 = { class: "lg:text-lg text-lg text-justify lg:leading-9 md:leading-7 leading-9 text-black mt-2 font-normal" }
const _hoisted_6 = { class: "flex md:flex-row flex-col md:space-x-8 md:mt-12 mt-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "md:w-7/12 lg:w-8/12 md:mt-8 sm:mt-8 mt-2 w-full h-full rounded-lg shadow-md bg-white shadow-curaduria border border-curaduria p-10 md:p-20" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-full md:block hidden"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-full md:hidden block"
  })
], -1)
const _hoisted_8 = { class: "md:w-7/12 lg:w-8/12 w-full md:mt-10 sm:mt-14 mt-10" }
const _hoisted_9 = { class: "flex justify-between items-center cursor-pointer" }
const _hoisted_10 = { class: "font-semibold text-xl leading-5 text-curaduria" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "#76184a",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "path1",
    class: "",
    d: "M10 4.1665V15.8332",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.16602 10H15.8327",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  id: "para1",
  class: "hidden font-normal text-base leading-6 text-gray-600 mt-4 w-11/12 text-justify"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", { class: "my-7 bg-gray-200" }, null, -1)
const _hoisted_15 = { class: "flex justify-between items-center cursor-pointer" }
const _hoisted_16 = { class: "font-semibold text-xl leading-5 text-curaduria" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "path2",
    class: "",
    d: "M10 4.1665V15.8332",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.16602 10H15.8327",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  id: "para2",
  class: "hidden font-normal text-base leading-6 text-gray-600 mt-4 w-11/12 text-justify"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", { class: "my-7 bg-gray-200" }, null, -1)
const _hoisted_21 = { class: "flex justify-between items-center cursor-pointer" }
const _hoisted_22 = { class: "font-semibold text-xl leading-5 text-curaduria" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "path3",
    d: "M10 4.1665V15.8332",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.16602 10H15.8327",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  id: "para3",
  class: "hidden font-normal text-base leading-6 text-gray-600 mt-4 w-11/12 text-justify"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", { class: "my-7 bg-gray-200" }, null, -1)
const _hoisted_27 = { class: "flex justify-between items-center cursor-pointer" }
const _hoisted_28 = { class: "font-semibold text-xl leading-5 text-curaduria" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "path4",
    d: "M10 4.1665V15.8332",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.16602 10H15.8327",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  id: "para4",
  class: "hidden font-normal text-base leading-6 text-gray-600 mt-4 w-11/12 text-justify"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", { class: "my-7 bg-gray-200" }, null, -1)
const _hoisted_33 = { class: "flex justify-between items-center cursor-pointer" }
const _hoisted_34 = { class: "font-semibold text-xl leading-5 text-curaduria" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "path6",
    d: "M10 4.1665V15.8332",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.16602 10H15.8327",
    stroke: "currentColor",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", {
  id: "para6",
  class: "hidden font-normal text-base leading-6 text-gray-600 mt-4 w-11/12 text-justify"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-full md:block"
  })
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("hr", { class: "my-7 bg-gray-200" }, null, -1)
const _hoisted_39 = { class: "w-full flex flex-col justify-content-center items-center" }
const _hoisted_40 = { class: "font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-curaduria" }
const _hoisted_41 = { class: "flex flex-wrap mt-6" }
const _hoisted_42 = { class: "relative z-10 mx-auto max-w-7xl px-4 pb-32 sm:px-6 lg:px-8" }
const _hoisted_43 = { class: "grid grid-cols-1 gap-y-20 lg:grid-cols-2 lg:gap-y-4 lg:gap-x-8" }
const _hoisted_44 = { class: "relative flex-1 px-6 pt-16 pb-8 md:px-8" }
const _hoisted_45 = { class: "text-xl font-medium text-gray-900" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("us.title")), 1),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("us.des")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("us.mision")), 1),
                _createElementVNode("button", {
                  "aria-label": "too",
                  class: "text-curaduria cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800",
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.openAnsSection(1)))
                }, _hoisted_12)
              ]),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("us.desMision")), 1)
            ]),
            _hoisted_14,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t("us.vision")), 1),
                _createElementVNode("button", {
                  "aria-label": "too",
                  class: "text-curaduria cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800",
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.openAnsSection(2)))
                }, _hoisted_18)
              ]),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("us.desVision")), 1)
            ]),
            _hoisted_20,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.$t("us.politica")), 1),
                _createElementVNode("button", {
                  "aria-label": "too",
                  class: "text-curaduria cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800",
                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.openAnsSection(3)))
                }, _hoisted_24)
              ]),
              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("us.desPolitica")), 1)
            ]),
            _hoisted_26,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.$t("us.funciones")), 1),
                _createElementVNode("button", {
                  "aria-label": "too",
                  class: "text-curaduria cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800",
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.openAnsSection(4)))
                }, _hoisted_30)
              ]),
              _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("us.desFunciones")), 1)
            ]),
            _hoisted_32,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.$t("us.organigrama")), 1),
                _createElementVNode("button", {
                  "aria-label": "too",
                  class: "text-curaduria cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800",
                  onClick: _cache[4] || (_cache[4] = $event => (_ctx.openAnsSection(6)))
                }, _hoisted_36)
              ]),
              _hoisted_37
            ]),
            _hoisted_38
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("h2", _hoisted_40, _toDisplayString(_ctx.$t("us.team")), 1)
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("section", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportLinks, (link) => {
              return (_openBlock(), _createElementBlock("div", {
                key: link.name,
                class: "flex flex-col rounded-2xl bg-white shadow-md"
              }, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("h3", _hoisted_45, _toDisplayString(link.name), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.paragraph, (p, i) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: i,
                      class: "mt-4 text-base text-gray-500 text-justify"
                    }, _toDisplayString(p), 1))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}